/* ============================================================
   U2 Subscribe Tiers — drawer toggle + scroll-to-options
   Path: assets/custom-subscribe-tiers.js
   ============================================================ */

(function () {
  'use strict';

  // Honor user's motion preferences — instant scroll instead of smooth
  // when reduced motion is requested at the OS level.
  var REDUCED_MOTION = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /**
   * Scroll the first product row inside the opened drawer to roughly
   * mid-viewport. Falls back to the drawer itself if no rows exist
   * (e.g. merchant added a tier card but no product option blocks yet).
   */
  function scrollFirstRowIntoView(drawer) {
    if (!drawer) return;

    var firstRow = drawer.querySelector('.u2-st__row');
    var target = firstRow || drawer;

    // Wait one frame so the browser has actually applied the [hidden]
    // removal + layout reflow before we measure & scroll. Without this,
    // scrollIntoView can land on the pre-open position.
    window.requestAnimationFrame(function () {
      target.scrollIntoView({
        behavior: REDUCED_MOTION ? 'auto' : 'smooth',
        block: 'center',    // centers row vertically — sticky header friendly
        inline: 'nearest'
      });
    });
  }

  function init(root) {
    var tiers = root.querySelectorAll('[data-tier]');
    var drawers = root.querySelectorAll('[data-drawer]');

    function closeAll() {
      tiers.forEach(function (t) { t.setAttribute('aria-selected', 'false'); });
      drawers.forEach(function (d) { d.hidden = true; });
    }

    function openTier(which) {
      tiers.forEach(function (t) {
        var match = t.dataset.tier === which;
        t.setAttribute('aria-selected', match ? 'true' : 'false');
      });
      drawers.forEach(function (d) {
        d.hidden = d.dataset.drawer !== which;
      });
    }

    tiers.forEach(function (tier) {
      tier.addEventListener('click', function (evt) {
        // Defensive: if a product-row select button click somehow bubbled
        // up to a tier card (shouldn't happen given DOM structure, but
        // keep the guard in case markup changes).
        if (evt.target.closest('.u2-st__select-btn')) return;

        var which = tier.dataset.tier;
        var alreadyOpen = tier.getAttribute('aria-selected') === 'true';

        if (alreadyOpen) {
          // Re-click on an open tier closes everything. No scroll on close —
          // jumping the page when the user is collapsing the drawer is jarring.
          closeAll();
          return;
        }

        openTier(which);

        // Find the matching drawer (sibling of the tier card in the grid)
        // and scroll its first product row into roughly the viewport center.
        var drawer = root.querySelector('[data-drawer="' + which + '"]');
        scrollFirstRowIntoView(drawer);
      });

      tier.addEventListener('keydown', function (evt) {
        if (evt.key === 'Enter' || evt.key === ' ') {
          evt.preventDefault();
          tier.click();
        }
      });
    });
  }

  function boot() {
    document.querySelectorAll('[data-u2-subscribe-tiers]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  /* Re-init for Shopify theme editor (block add/reorder) */
  document.addEventListener('shopify:section:load', function (evt) {
    var section = evt.target.querySelector('[data-u2-subscribe-tiers]');
    if (section) init(section);
  });
})();